import React from "react";
const FollowFunc = ({id, component, follow, followed, unFollow, waitingSubscripe}) => {
    return (
        <>
            {!followed && <div className={'normal-button users__normal-button_second'}>
                <button onClick={() => follow(id)} disabled={waitingSubscripe.includes(id)}>Подписаться</button>
            </div>}

            {followed && <div className={'normal-button users__normal-button_three'}>
                <button onClick={() => unFollow(id)} disabled={waitingSubscripe.includes(id)}>
                    Отписаться
                </button>
            </div>}
        </>
    )
};

export default FollowFunc